import React from "react";
import MainMenu from "../../components/MainMenu";
import Button from "@mui/material/Button";
import { Grid, Paper } from "@mui/material";
import PlayerProfile from "../../components/PlayersAreaComponents/PlayerProfile";

function PlayerProfilePage() {
  return (
    <MainMenu>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3}>
            <PlayerProfile />
          </Paper>
        </Grid>
      </Grid>
    </MainMenu>
  );
}

export default PlayerProfilePage;
